import { gql } from "graphql-tag";

export const APPLICANT_SEARCH_QUERY = gql`
  query ApplicantSearch(
    $elasticQuery: ElasticQuery!,
    $interestListIds: [ID!]!,
    $page: Int,
    $pageSize: Int
  ) {
    applicantSearch(
      elasticQuery: $elasticQuery,
      interestListIds: $interestListIds,
      page: $page,
      pageSize: $pageSize
      ) {
      page
      pageSize
      hits
      items {
        userId
        applicantName
        applicantFirstName
        applicantLastName
        applicantPhone
        applicantEmail
        householdMember0FirstName
        householdMember0LastName
        residenceCity
        householdIncome
        ownerNames
        ownerUserIds
        isComplete
        hasPositionNumber
        hasUserId
        positionNumber
        hasStar
        id
        interestListId
        skips
        status
        weight
        lastStatusChange
        currentRemovalReason
        submittedAt

        hasHouseholdIncome
        householdCount
        householdGrossAnnualIncome
        householdMember0Email
        householdMember0Gender
        householdMember0MiddleName
        prefLang
        unitSize1br
        unitSize1brDen
        unitSize2br
        unitSize3br
        unitSize4br
        unitSize5br
        unitSizeShared
        unitSizeSro
        unitSizeStudio


        isDuplicate
        householdHasHousingAuthorityVoucher
        householdReceivesOtherHousingAssistance
      }
    }
  }
  `;
// snake-cased values ruin the gql:gen:both command.
// temp solution is to remove them when running the command

// last 4 statuses are pulled from attributesToRetrieve in index
// isDuplicate and lastStatusChange might no longer be in use

// The Owner column's editor loads owners by id: the search index omits nameless
// owners from ownerNames, so its lists can't be paired up.
export const INTEREST_OWNERS_QUERY = gql`
  query InterestOwners($interestId: ID!) {
    interest(id: $interestId) {
      id
      owners {
        id
        firstName
        lastName
      }
    }
  }
`;
